import React from 'react';

import styles from './dropdown.module.css';

export default class Dropdown extends React.PureComponent {
  constructor(props) {
    super(props);

    this.selfRef = React.createRef();

    this.handleToggle = this.handleToggle.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      document.addEventListener('mousedown', this.handleOutsideClick);
      document.addEventListener('touchstart', this.handleOutsideClick);
    } else if (prevProps.open && !this.props.open) {
      document.removeEventListener('mousedown', this.handleOutsideClick);
      document.removeEventListener('touchstart', this.handleOutsideClick);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
    document.removeEventListener('touchstart', this.handleOutsideClick);
  }

  handleToggle() {
    if (this.props.disabled) {
      return;
    }

    this.props.onOpenChange(!this.props.open);
  }

  handleClose() {
    this.props.onOpenChange(false);
  }

  handleOutsideClick(e) {
    if (this.selfRef.current && !this.selfRef.current.contains(e.target)) {
      this.handleClose();
    }
  }

  render() {
    return (
      <div className={[styles.dropdown, this.props.className].join(' ')} ref={this.selfRef}>
        {this.props.trigger({
          open: this.props.open,
          disabled: this.props.disabled,
          onClick: this.handleToggle,
        })}

        {this.props.open ? (
          <div className={[styles.menu, this.props.menuClassName].join(' ')} onClick={this.handleClose}>
            {this.props.children}
          </div>
        ) : null}
      </div>
    );
  }
}
